import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import API from "../lib/api";
import { ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get(`/blog/${postId}`).then(r => setPost(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [postId]);

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="w-6 h-6 border-2 border-[#00FF41] border-t-transparent animate-spin" />
    </div>
  );

  if (!post) return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F0F0F0] flex items-center justify-center">
      <div className="text-center">
        <p className="text-lg font-medium mb-4">Post not found</p>
        <Link to="/blog" className="text-[#00FF41] text-sm">Back to Blog</Link>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F0F0F0]" data-testid="blog-post-page">
      <nav className="border-b border-[#1E1E1E]">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="font-heading text-xl font-black tracking-tighter uppercase">
            NRD<span className="text-[#00FF41]">.</span>
          </Link>
          <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#00FF41] transition-colors" data-testid="blogpost-back">
            <ArrowLeft size={14} /> All Posts
          </Link>
        </div>
      </nav>

      <article className="max-w-3xl mx-auto px-6 py-16">
        <span className="text-xs font-mono uppercase tracking-[0.2em] text-[#00FF41]">{post.category}</span>
        <h1 className="font-heading text-3xl lg:text-4xl font-bold tracking-tight mt-3 mb-4" data-testid="blogpost-title">{post.title}</h1>
        <p className="text-sm text-slate-500 mb-8">By {post.author} &middot; {new Date(post.created_at).toLocaleDateString()}</p>
        {post.cover_image && (
          <div className="aspect-[16/9] overflow-hidden border border-[#1E1E1E] mb-8">
            <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover opacity-80" />
          </div>
        )}
        <div className="text-base text-slate-300 leading-relaxed whitespace-pre-line" data-testid="blogpost-content">
          {post.content}
        </div>
      </article>
    </div>
  );
}
